import { PhoneNumberFormats } from '../phoneNumberFormatsByCountry'
import { US } from './US'

export const PR: PhoneNumberFormats = {
  ...US,
  placeholder: '(787) 123-4567'
}
